/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Goals_EyebrowInputs */

const en_for_whom_goals_eyebrow = /** @type {(inputs: For_Whom_Goals_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goals`)
};

const pl_for_whom_goals_eyebrow = /** @type {(inputs: For_Whom_Goals_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele`)
};

/**
* | output |
* | --- |
* | "Goals" |
*
* @param {For_Whom_Goals_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_goals_eyebrow = /** @type {((inputs?: For_Whom_Goals_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Goals_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_goals_eyebrow(inputs)
	return en_for_whom_goals_eyebrow(inputs)
});